const config = {
  stripe: {
    apiKey: 'pk_live_51HXZ6CLHs0uQh4VnBLUhZQlnUngfRNrvXpDHX8VI9q3ufVY08ekI1Upox69fB9PqDkmM5JG8bwNCaVMBuTvRuwh400S8VcS3Qw',
    apiUrl: 'https://xujrgzg7q4.execute-api.us-east-1.amazonaws.com/live/generateCode',
    currency: 'USD',
  },
};

export default config;
